/** Monetary field keys; avoids bare `value` (e.g. defaultValue, enumValue). */
export const MONEY_KEY =
  /amount|price|commission|fee|balance|interest|cost|proceeds|principal|(?:^|_)value$|(?:market|book|face|net|total|cash|fair|nominal|gross|notional|settlement)Value$/i;

export const DATE_KEY = /date|at$/i;

export const ACTIVITY_ORDER = [
  'transactionType',
  'transaction_type',
  'status',
  'symbol',
  'quantity',
  'price',
  'commission',
  'accruedInterest',
  'accrued_interest',
  'amount',
  'currency',
  'tradeDate',
  'trade_date',
  'settleDate',
  'settle_date',
] as const;

export const SYSTEM_ID_ORDER = [
  'transactionId',
  'transaction_id',
  'subTransactionId',
  'sub_transaction_id',
  'subTransId',
  'sub_trans_id',
  'cusip',
  'CUSIP',
  'financialProductId',
  'financial_product_id',
  'finProductId',
  'fin_product_id',
] as const;

export const ACCOUNT_ORDER = [
  'id',
  '_id',
  'clientName',
  'client_name',
  'accountType',
  'account_type',
  'baseCurrency',
  'base_currency',
  'accountStatus',
  'account_status',
  'status',
  'custodianAccountNumber',
  'custodian_account_number',
  'custodianName',
  'custodian_name',
  'custodian',
] as const;

export const RESERVED_ROOT_KEYS = new Set([
  'account',
  'activity',
  'systemIdentifiers',
  'system_identifiers',
  'user',
]);
